import { alpha } from "@mui/material";

export const PRIMARY = "#D0749B";

export const COLOR_PRESETS = [
  "#F69195", "#DAA1BB", "#F3B98D", "#B9DBCD", "#E6AB93",
  "#B0A1A3", "#D09267", "#D0749B", "#7C6AE8", "#4CAF50",
  "#FF9800", "#2196F3", "#9C27B0", "#E91E63", "#00BCD4",
];

export const sx = {
  // ── Upload banner ──
  uploadBanner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    p: 4,
    mt: 4,
    mx: "auto",
    maxWidth: 420,
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    borderRadius: 4,
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
    backdropFilter: "blur(6px)",
    textAlign: "center",
    transition: "all 0.3s ease-in-out",
  },

  // ── Header ──
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    px: 3,
    pt: 2,
    pb: 1,
  },
  categoryChip: {
    bgcolor: alpha(PRIMARY, 0.12),
    color: PRIMARY,
    fontWeight: 600,
  },
  btnUploadLive: {
    borderColor: PRIMARY,
    color: PRIMARY,
    "&:hover": { borderColor: alpha(PRIMARY, 0.85), bgcolor: alpha(PRIMARY, 0.06) },
    borderRadius: 2,
    textTransform: "none",
    fontWeight: 600,
  },
  btnNewCategory: {
    bgcolor: PRIMARY,
    "&:hover": { bgcolor: alpha(PRIMARY, 0.85) },
    borderRadius: 2,
    textTransform: "none",
    fontWeight: 600,
  },

  // ── Categories grid ──
  categoriesGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "1%",
    gap: "4%",
  },

  // ── Loader backdrop ──
  loaderBackdrop: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 10,
  },

  // ── Category detail modal ──
  categoryDetailContainer: {
    backgroundColor: "white",
    borderRadius: 5,
    minWidth: "65vh",
    maxHeight: "80vh",
    overflow: "auto",
  },
  categoryDetailHeader: {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "3% 4% 2% 4%",
    borderBottom: "1px solid #ddd",
  },
  emptyLivesText: {
    color: "GrayText",
    textAlign: "center",
    paddingTop: "13%",
  },

  // ── Dialog ──
  dialogIconPreview: (color) => ({
    width: 40,
    height: 40,
    borderRadius: 2,
    bgcolor: color,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  dialogCloseBtn: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "text.disabled",
  },
  textFieldFocused: (color) => ({
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: color,
    },
    "& label.Mui-focused": { color },
  }),
  colorSwatch: (color, isSelected) => ({
    width: 28,
    height: 28,
    borderRadius: "50%",
    bgcolor: color,
    cursor: "pointer",
    border: isSelected ? "3px solid #333" : "3px solid transparent",
    transition: "all 0.15s",
    "&:hover": { transform: "scale(1.15)" },
  }),
  colorPickerBox: {
    width: 40,
    height: 40,
    borderRadius: 2,
    border: "2px solid #ddd",
    cursor: "pointer",
    overflow: "hidden",
    position: "relative",
  },
  colorInput: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: 0,
    cursor: "pointer",
  },
  activeToggle: (isActive) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    px: 1.5,
    py: 1,
    borderRadius: 2,
    bgcolor: isActive ? alpha("#2e7d32", 0.06) : alpha("#000", 0.03),
    border: `1px solid ${isActive ? alpha("#2e7d32", 0.2) : "transparent"}`,
  }),
  switchActive: {
    "& .MuiSwitch-switchBase.Mui-checked": { color: "#2e7d32" },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      bgcolor: "#2e7d32",
    },
  },
  dialogPaper: (color) => ({
    borderRadius: 3,
    border: `1px solid ${alpha(color, 0.3)}`,
  }),
  btnSave: (color) => ({
    bgcolor: color,
    "&:hover": { bgcolor: alpha(color, 0.85) },
    borderRadius: 2,
    textTransform: "none",
    fontWeight: 600,
  }),
};
